<template>
  <div>
    <div class="p-2 ">
      <div
        class="flex space-x-2 mb-2 flex-1 items-center"
        @click="addForm = !addForm"
      >
        <span class="global-button cursor-pointer">
          Yeni kişi
        </span>
      </div>
    </div>
    <div class="border p-4 rounded-lg" v-if="addForm">
      <h4 class="text-sm font-medium">YENİ KİŞİ EKLEME FORMU</h4>

      <div class="flex space-x-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-20 h-20 text-tile"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M14 12.25a3.75 3.75 0 1 1 3.75-3.75A3.75 3.75 0 0 1 14 12.25m0-6a2.25 2.25 0 1 0 2.25 2.25A2.25 2.25 0 0 0 14 6.25m7 13a.76.76 0 0 1-.75-.75c0-1.95-1.06-3.25-6.25-3.25s-6.25 1.3-6.25 3.25a.75.75 0 0 1-1.5 0c0-4.75 5.43-4.75 7.75-4.75s7.75 0 7.75 4.75a.76.76 0 0 1-.75.75M8.32 13.06H8a3 3 0 1 1 .58-6a.75.75 0 1 1-.15 1.49a1.46 1.46 0 0 0-1.09.34a1.47 1.47 0 0 0-.54 1a1.49 1.49 0 0 0 1.35 1.64a1.53 1.53 0 0 0 .93-.22a.75.75 0 0 1 .79 1.28a3 3 0 0 1-1.55.47M3 18.5a.76.76 0 0 1-.75-.75c0-2.7.72-4.5 4.25-4.5a.75.75 0 0 1 0 1.5c-2.35 0-2.75.75-2.75 3a.76.76 0 0 1-.75.75"
          />
        </svg>


        <form
          method="post"
          action="javascript:void(0)"
          @submit.prevent="saveForm()"
        >
          <div>
            <label>İsim ve soyisim</label>
            <input class="uk-input w-full" v-model="form.name" />
          </div>
          <div>
            <label>T.C.</label>
            <input class="uk-input w-full" v-model="form.tc" />
          </div>
          <div>
            <label>Şehir</label>
            <input class="uk-input w-full" v-model="form.city" />
          </div>
          <div>
            <label>İlçe</label>
            <input class="uk-input w-full" v-model="form.ilce" />
          </div>   <div>
            <label>E-posta</label>
            <input class="uk-input w-full" v-model="form.email" />
          </div>
          <div>
            <label>Açıklama</label>
            <textarea
              class="uk-textarea border rounded-lg w-full"
              v-model="form.description"
            ></textarea>
          </div>

          <savebutton
            action="saveDeposit"
            class="mt-4"
            title="Oluştur"
          ></savebutton>
        </form>
      </div>
    </div>

    <div v-if="loading == false">
      <table
        v-if="remitters.length > 0"
        class="uk-table journal-table uk-table-hover heightoverflow uk-table-middle uk-table-divider"
      >
        <tr>
          <th>AD SOYAD</th>
          <th>TC</th>
          <th>ŞEHİR</th>
          <th>İLÇE</th>
          <th>AÇIKLAMA</th>
          <th>E-POSTA</th>
          <th>OLUŞTURULMA TARİHİ</th>
        </tr>
        <tr v-for="dlead in remitters" :key="dlead.id">
          <td>{{ dlead.name }}</td>
          <td>{{ dlead.tc }}</td>
          <td>{{ dlead.city }}</td>
          <td>{{ dlead.ilce }}</td>
          <td>{{ dlead.description }}</td>
          <td>{{ dlead.email }}</td>
          <td>{{ dlead.created_at }}</td>
        </tr>
      </table>

      <div v-else class="flex items-center justify-center flex-col ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-40 h-40 text-tile"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M14 12.25a3.75 3.75 0 1 1 3.75-3.75A3.75 3.75 0 0 1 14 12.25m0-6a2.25 2.25 0 1 0 2.25 2.25A2.25 2.25 0 0 0 14 6.25m7 13a.76.76 0 0 1-.75-.75c0-1.95-1.06-3.25-6.25-3.25s-6.25 1.3-6.25 3.25a.75.75 0 0 1-1.5 0c0-4.75 5.43-4.75 7.75-4.75s7.75 0 7.75 4.75a.76.76 0 0 1-.75.75M8.32 13.06H8a3 3 0 1 1 .58-6a.75.75 0 1 1-.15 1.49a1.46 1.46 0 0 0-1.09.34a1.47 1.47 0 0 0-.54 1a1.49 1.49 0 0 0 1.35 1.64a1.53 1.53 0 0 0 .93-.22a.75.75 0 0 1 .79 1.28a3 3 0 0 1-1.55.47M3 18.5a.76.76 0 0 1-.75-.75c0-2.7.72-4.5 4.25-4.5a.75.75 0 0 1 0 1.5c-2.35 0-2.75.75-2.75 3a.76.76 0 0 1-.75.75"
          />
        </svg>

        <span class="text-lg font-semibold text-black"
          >3.Şahış kaydı bulunamadı</span
        >
        <span class="text-sm font-light text-gray-400"
          >Bu lead için atanmış 3.şahış kaydı bulunamadı</span
        >
      </div>
    </div>
    <div v-else class="center">
      <vk-spinner ratio="2"></vk-spinner>
    </div>
  </div>
</template>

<script>
import httpService from "../../../services/http";
import EventBus from "../EventBus";

export default {
  data() {
    return {
      remitters: [],
      form: [],
      loading: true,
      addForm: false,
    };
  },
  props: ["id"],
  mounted() {
    this.getDublicated();
  },
  methods: {
    saveForm() {
      if (this.form.tc) {
        this.form.lead_id = this.id;
        this.form.agent_id = this.id;
        this.$parent.$emit("loading", true);
        EventBus.$emit("loadingStatus", {
          action: "save_lead_remitters",
          loading: true,
        });

        httpService
          .inlineSave({
            table: "lead_remitters",
            type: "insert",
            inputs: this.form,
          })
          .then(() => {
            EventBus.$emit("loadingStatus", {
              action: "save_lead_remitters",
              loading: false,
              success: true,
            });

            this.getDublicated();
          });
      }
    },
    getDublicated() {
      httpService
        .getData({
          table: "lead_remitters",
          filters: [
            {
              name: "lead_id",
              value: this.id,
              type: 1,
            },
          ],
        })
        .then((response) => {
          this.loading = false;
          this.remitters = response.data.results;
        });
    },
  },
};
</script>
